import Topnavbar from "../../../Layouts/Topnavbar"
import { Container, Grid, Paper, Title, ThemeIcon, Group, ActionIcon, Button, Drawer, Menu, Modal, Stack, TextInput, PinInput, NumberInput, Badge, Text } from "@mantine/core";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Select,
    Input,
    Space,
    Card, message, Descriptions, Divider
} from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { Get_User_Details, Get_users_topin_requests, Revert_AdvanceCredit_Fund, Update_user_topin_requests } from "../../../apicall";
import { IconChevronDown } from "@tabler/icons-react";
import { useWallet } from "../../../Context/Walletcontext";

const { RangePicker } = DatePicker;
const { Search } = Input;
// const { Text } = Typography;










const Fundrequest = ({ Headername }) => {
    // const columns = [
    //     {
    //         title: "S.No.",
    //         dataIndex: "sno",
    //         width: 120,
    //     },
    //     {
    //         title: "Date & Time",
    //         dataIndex: "dateandtime",
    //         width: 120,
    //     },
    //     {
    //         title: "UTR",
    //         dataIndex: "utr",
    //         width: 120,
    //     },

    //     {
    //         title: "User details",
    //         dataIndex: "userdetails",
    //         width: 120,
    //     },
    //     {
    //         title: "Req type",
    //         dataIndex: "reqtype",
    //         width: 120,
    //     },
    //     {
    //         title: "Req details",
    //         dataIndex: "reqdetails",
    //         width: 120,
    //     },
    //     {
    //         title: "Amount",
    //         dataIndex: "amount",
    //         width: 120,
    //     },
    //     {
    //         title: "Status",
    //         dataIndex: "status",
    //         width: 120,
    //     },
    //     {
    //         title: "Remarks & Slip",
    //         dataIndex: "remarksandslip",
    //         width: 120,
    //     },

    //     {
    //         title: "Action",
    //         dataIndex: "requestId",
    //         width: 120,
    //         render: (_, record) => {
    //             const items = [
    //                 {
    //                     key: "1",
    //                     label: "Approve",
    //                 },
    //                 {
    //                     key: "2",
    //                     label: "Reject",
    //                 },
    //                 {
    //                     key: "3",
    //                     label: "Approve with fees",
    //                 },
    //                 // {
    //                 //     key: "3",
    //                 //     label: "Refund Request",
    //                 // },
    //             ];

    //             return (
    //                 <Dropdown
    //                     menu={{
    //                         items,
    //                         onClick: ({ key }) => {
    //                             switch (key) {
    //                                 case "1":
    //                                     console.log("Approve", record);
    //                                     break;
    //                                 case "2":
    //                                     console.log("Reject", record);
    //                                     break;
    //                                 case "3":
    //                                     console.log("Approve with fees", record);
    //                                     break;
    //                                 default:
    //                                     break;
    //                             }
    //                         },
    //                     }}
    //                     trigger={["click"]}
    //                 >
    //                     <Button type="text" size="small">Select Action </Button>
    //                 </Dropdown>
    //             );
    //         },
    //     },
    // ];
    const { refreshWallet } = useWallet();
    const today = dayjs();
    const [dateRange, setDateRange] = useState([
        today.startOf("day"),
        today.endOf("day"),
    ]);
    const [status, setStatus] = useState("ALL");
    const [reqTypes, setReqtypes] = useState("ALL");
    const [utr, setUtr] = useState("");
    const { user } = Userauthcontexthooks();
    const [topinreqloading, settopinreqloading] = useState(true);
    const [allTopinReq, setAllTopinReq] = useState([]);
    const [topinReq, setTopinreq] = useState([]);
    const [detailsDrawer, setDetailsDrawer] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [selfProfiledetails, setProfiledetails] = useState(''); // Self profile 
    const [approveType, setApproveType] = useState("");
    const [approveModal, setApproveModal] = useState(false);
    const [rejectModal, setRejectModal] = useState(false);
    const [advanccreditrevertRemarks, setadvanccreditrevertRemarks] = useState('');
    const [advancecreditrevertModal, setadvancecreditrevertModal] = useState(false);
    const [revertloading, setrevertloading] = useState(false); // Advance credit
    const [approveForm, setApproveForm] = useState({
        fee: 0,
        status: "",
        adminaction: "",
        adminapproveremarks: "",
        adminrejectremarks: "",
    });
    const [mpin, setmpin] = useState('');
    const [approveloading, setapproveloading] = useState(false);
    const [rejectloading, setrejectloading] = useState(false);

    const handleSearch = () => {

        let filtered = [...allTopinReq];

        if (status !== "ALL") {

            filtered = filtered.filter(
                item => item.status === status
            );

        }

        if (reqTypes !== "ALL") {
            filtered = filtered.filter(
                item => item.depositeType === reqTypes
            );

        }

        if (utr.trim()) {

            filtered = filtered.filter(item =>
                item.utr
                    ?.toLowerCase()
                    .includes(utr.toLowerCase())
            );

        }

        setTopinreq(filtered);

    }

    const handleReset = () => {

        const today = dayjs();

        setDateRange([
            today.startOf("day"),
            today.endOf("day")
        ]);

        setStatus("ALL");
        setReqtypes("ALL");

        setUtr("");

        // No need to manually reset topinReq.
        // dateRange changes → backend fetches today's data.
    }

    const finalAmount = Math.max(
        Number(selectedRequest?.amount || 0) -
        Number(approveForm.fee || 0),
        0
    );;

    const fetchTopinRequests = async () => {

        try {
            const data = await Get_users_topin_requests(
                dateRange[0].format("YYYY-MM-DD"),
                dateRange[1].format("YYYY-MM-DD")
            );

            if (data.success) {
                //console.log(data);

                setAllTopinReq(data?.topinRequests);

                setTopinreq(data?.topinRequests);
            }

        } catch (error) {

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            settopinreqloading(false);
        }

    }

    const columns = [
        {
            title: "Req. ID",
            dataIndex: "topinId",
            width: 20,
        },

        {
            title: "Status",
            dataIndex: "status",
            width: 20,
            render: (status) => {
                let color = "default";

                if (status === "SUCCESS") color = "green";
                if (status === "PENDING") color = "orange";
                if (status === "FAILED") color = "red";

                return <Tag color={color}>{status}</Tag>;
            },
        },

        {
            title: "Mode",
            dataIndex: "depositeType",
            width: 20,
        },

        {
            title: "UTR",
            dataIndex: "utr",
            width: 180,
            render: (utr) => <Text copyable>{utr}</Text>,
        },

        {
            title: "Amount",
            dataIndex: "amount",
            align: "right",
            width: 80,
            render: (amount) => `₹ ${amount.toLocaleString()}`,
        },

        {
            title: "Fee",
            dataIndex: "fee",
            align: "right",
            width: 80,
            render: (fee) => `₹ ${fee?.toLocaleString()}`,
        },

        {
            title: "Net Amount",
            dataIndex: "netAmount",
            align: "right",
            width: 80,
            render: (net) => (
                <Text strong style={{ color: "#1677ff" }}>
                    ₹ {net?.toLocaleString()}
                </Text>
            ),
        },

        {
            title: "Date",
            dataIndex: "createdAt",
            align: "right",
            width: 120,
            render: (date) => (
                <>
                    <div>{dayjs(date).format("DD MMM YYYY")}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        {dayjs(date).format("hh:mm A")}
                    </Text>
                </>
            ),
        },

        {
            title: "Remarks",
            width: 150,
            align: "right",
            render: (_, record) => {
                const admin = record.adminRemarks;

                return (
                    <>
                        <Tag
                            color={
                                admin?.adminaction === "APPROVED"
                                    ? "green"
                                    : admin?.adminaction === "REJECTED"
                                        ? "red"
                                        : "orange"
                            }
                        >
                            {admin?.adminaction || "Pending"}
                        </Tag>

                        <div style={{ marginTop: 4 }}>
                            <Text type="secondary">
                                {admin?.adminapproveremarks ||
                                    admin?.adminrejectremarks ||
                                    record.remarks ||
                                    "-"}
                            </Text>
                        </div>
                    </>
                );
            },
        },
        {
            title: "Action",
            width: 100,
            align: "center",
            render: (_, record) => (
                <Button
                    size="xs"
                    variant="outline"

                    onClick={() => {
                        setSelectedRequest(record);
                        setDetailsDrawer(true);
                    }}
                >
                    View
                </Button>
            )
        }
    ];

    const handelApprove_Request = async () => {
        const { fee, adminapproveremarks } = approveForm
        if (approveType === 'WITH_FEE' && !fee) {
            message.error('Fee is required');
            return;
        }
        if (mpin === '' || mpin.length !== 6) {
            message.error("Please enter your 6 digit MPIN");
            return;
        }

        const body = {
            topinId: selectedRequest?.topinId,
            userId: selectedRequest?.userId,
            fee: fee,
            status: 'SUCCESS',
            adminby: selfProfiledetails?._id,
            adminaction: 'APPROVED',
            adminapproveremarks: adminapproveremarks,
            mpin
        }

        try {
            setapproveloading(true);
            // API CALL HERE
            const data = await Update_user_topin_requests(body);
            if (data.success) {
                message.success(data.message);
                setApproveModal(false);
                setApproveForm({
                    fee: 0,
                    status: "",
                    adminaction: "",
                    adminapproveremarks: "",
                    adminrejectremarks: "",
                })
                setmpin('');
                // setDistributordetails('');
                await refreshWallet(); // update the wallet in real time. 
                fetchTopinRequests();
            }

        } catch (error) {

            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setapproveloading(false);
        }

    }

    const handelReject_Request = async () => {
        const { adminrejectremarks, fee } = approveForm
        if (!adminrejectremarks) {
            message.error('Reject remarks is required');
            return;
        }
        if (mpin === '' || mpin.length !== 6) {
            message.error("Please enter your 6 digit MPIN");
            return;
        }

        const body = {
            topinId: selectedRequest?.topinId,
            userId: selectedRequest?.userId,
            fee: fee,
            status: 'FAILED',
            adminby: selfProfiledetails?._id,
            adminaction: 'REJECTED',
            adminrejectremarks: adminrejectremarks,
            mpin
        }

        try {
            setrejectloading(true);
            // API CALL HERE
            const data = await Update_user_topin_requests(body);
            if (data.success) {
                message.success(data.message);
                setRejectModal(false);
                setApproveForm({
                    fee: 0,
                    status: "",
                    adminaction: "",
                    adminapproveremarks: "",
                    adminrejectremarks: "",
                })
                setmpin('');
                // setDistributordetails('');
                await refreshWallet(); // update the wallet in real time. 
                fetchTopinRequests();
            }

        } catch (error) {

            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setrejectloading(false);
        }

    }

    const handelRevert_Request = async () => {
        if (!advanccreditrevertRemarks) {
            message.error('Revert remarks is required');
            return;
        }
        if (mpin === '' || mpin.length !== 6) {
            message.error("Please enter your 6 digit MPIN");
            return;
        }

        const body = {
            topInid: selectedRequest?._id,
            revertamount: selectedRequest?.amount,
            usertype: selectedRequest?.userType,
            userid: selectedRequest?.userId,
            remarks: advanccreditrevertRemarks,
            mpin
        }

        try {
            setrevertloading(true);
            // API CALL HERE
            const data = await Revert_AdvanceCredit_Fund(body);
            if (data.success) {
                message.success(data.message);
                setadvancecreditrevertModal(false);
                setadvanccreditrevertRemarks('');
                setmpin('');
                setDetailsDrawer(false);
                // setDistributordetails('');
                await refreshWallet(); // update the wallet in real time. 
                fetchTopinRequests();
            }

        } catch (error) {

            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setrevertloading(false);
        }

    }

    useEffect(() => {
        const GetUserprofile = async () => {
            try {
                const data = await Get_User_Details();
                if (data.success) {
                    //console.log(data);
                    setProfiledetails(data?.user)
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            }
        }
        const fetchTopinRequests = async () => {

            try {
                const data = await Get_users_topin_requests(
                    dateRange[0].format("YYYY-MM-DD"),
                    dateRange[1].format("YYYY-MM-DD")
                );

                if (data.success) {
                    //console.log(data);

                    setAllTopinReq(data?.topinRequests);

                    setTopinreq(data?.topinRequests);
                }

            } catch (error) {

                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                settopinreqloading(false);
            }

        }
        if (user) {
            fetchTopinRequests();
            GetUserprofile();
        }

    }, [user, dateRange]);
    //console.log(selectedRequest);

    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'} >
                <Title c={'dimmed'}>Fund Requests</Title>
                <Text size="xs">Approve/Reject users fund requests.</Text>
            </Container >

            <Container size={'lg'} mt={'lg'}>
                <Card title="Request History" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        <Col xs={24} md={8}>
                            <RangePicker
                                style={{ width: "100%" }}
                                value={dateRange}
                                onChange={(value) => setDateRange(value)}
                                allowClear={false}
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                value={reqTypes}
                                onChange={setReqtypes}
                                style={{ width: "100%" }}
                                options={[
                                    { label: "All Types", value: "ALL" },
                                    { label: "Branch Deposit", value: "Branch Deposit" },
                                    { label: "CDM Deposit", value: "CDM Deposit" },
                                    { label: "Online", value: "Online" },
                                    { label: "Cash By Hand", value: "Cash By Hand" },
                                    { label: "Advance Credit", value: "Advance Credit" },
                                ]}
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                value={status}
                                onChange={setStatus}
                                style={{ width: "100%" }}
                                options={[
                                    { label: "All Status", value: "ALL" },
                                    { label: "SUCCESS", value: "SUCCESS" },
                                    { label: "PENDING", value: "PENDING" },
                                    { label: "FAILED", value: "FAILED" },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search UTR"
                                allowClear
                                value={utr}
                                onChange={(e) => setUtr(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button onClick={handleSearch}>
                                    Search
                                </Button>

                                <Button onClick={handleReset} variant="light">Reset</Button>
                                <Button onClick={fetchTopinRequests} variant="outline">Refresh</Button>
                                <Button variant="outline">Download</Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={topinReq}
                            bordered
                            size="middle"
                            loading={topinreqloading}
                            rowKey="_id"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                        // scroll={{ x: 1200 }}
                        />
                    </div>
                </Card>
            </Container>

            <Drawer
                title="Top-In Request Details"
                placement="right"
                width={550}
                opened={detailsDrawer}
                onClose={() => {
                    setDetailsDrawer(false);
                    setSelectedRequest(null);
                }}
            >
                {selectedRequest && (
                    <>
                        {/* Request Details */}

                        <Divider orientation="left">
                            Request Details
                        </Divider>

                        <Descriptions
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="Request ID">
                                {selectedRequest.topinId}
                            </Descriptions.Item>
                            <Descriptions.Item label="User Type">
                                {selectedRequest.userType}
                            </Descriptions.Item>
                            <Descriptions.Item label="User Code">
                                {selectedRequest.userCode}
                            </Descriptions.Item>

                            <Descriptions.Item label="Status">
                                <Tag
                                    color={
                                        selectedRequest.status === "SUCCESS"
                                            ? "green"
                                            : selectedRequest.status === "FAILED"
                                                ? "red"
                                                : "orange"
                                    }
                                >
                                    {selectedRequest.status}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Deposit Type">
                                {selectedRequest.depositeType}
                            </Descriptions.Item>

                            <Descriptions.Item label="Deposit Date">
                                {dayjs(selectedRequest.depositeDate).format(
                                    "DD MMM YYYY"
                                )}
                            </Descriptions.Item>

                            <Descriptions.Item label="Created On">
                                {dayjs(selectedRequest.createdAt).format(
                                    "DD MMM YYYY hh:mm A"
                                )}
                            </Descriptions.Item>

                            <Descriptions.Item label="UTR">
                                <Text copyable>
                                    {selectedRequest.utr}
                                </Text>
                            </Descriptions.Item>

                            <Descriptions.Item label="Amount">
                                ₹ {selectedRequest.amount.toLocaleString()}
                            </Descriptions.Item>

                            <Descriptions.Item label="Fee">
                                ₹ {selectedRequest.fee.toLocaleString()}
                            </Descriptions.Item>

                            <Descriptions.Item label="Net Amount">
                                <Text strong style={{ color: "#1677ff" }}>
                                    ₹ {selectedRequest.netAmount?.toLocaleString()}
                                </Text>
                            </Descriptions.Item>

                            <Descriptions.Item label="User Remarks">
                                {selectedRequest.remarks || "-"}
                            </Descriptions.Item>

                        </Descriptions>

                        {/* Bank */}

                        <Divider orientation="left">
                            Bank Details
                        </Divider>

                        <Descriptions
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="A/C Number">
                                {selectedRequest.bank?.accountNumber || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="IFSC Code">
                                {selectedRequest.bank?.ifscCode || "-"}
                            </Descriptions.Item>

                        </Descriptions>

                        {/* Admin */}

                        <Divider orientation="left">
                            Admin Action
                        </Divider>

                        <Descriptions
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="Action">

                                <Tag
                                    color={
                                        selectedRequest.adminRemarks?.adminaction ===
                                            "APPROVED"
                                            ? "green"
                                            : selectedRequest.adminRemarks
                                                ?.adminaction === "REJECTED"
                                                ? "red"
                                                : "orange"
                                    }
                                >
                                    {selectedRequest.adminRemarks?.adminaction ||
                                        "Pending"}
                                </Tag>

                            </Descriptions.Item>

                            <Descriptions.Item label="Approved By">
                                {selectedRequest.adminRemarks?.adminby || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Approval Remarks">
                                {selectedRequest.adminRemarks
                                    ?.adminapproveremarks || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Reject Remarks">
                                {selectedRequest.adminRemarks
                                    ?.adminrejectremarks || "-"}
                            </Descriptions.Item>

                        </Descriptions>

                        <Group mt={'sm'} justify="center">
                            <Group mt="sm" justify="center">

                                {selectedRequest.status === "PENDING" && (

                                    <Menu shadow="md" width={250}>

                                        <Menu.Target>
                                            {/* <Button
                                                rightSection={<IconChevronDown size={16} />}
                                            >
                                                Approve
                                            </Button> */}
                                            {selectedRequest.status === 'PENDING' && <Button size="xs" rightSection={<IconChevronDown size={16} />}>Approve fund request</Button>}
                                        </Menu.Target>

                                        <Menu.Dropdown>

                                            <Menu.Item
                                                onClick={() => {
                                                    setApproveType("NORMAL");
                                                    setApproveModal(true);
                                                }}
                                            >
                                                Approve Fund Request
                                            </Menu.Item>

                                            <Menu.Item
                                                onClick={() => {
                                                    setApproveType("WITH_FEE");
                                                    setApproveModal(true);
                                                }}
                                            >
                                                Approve Fund Request with Fee
                                            </Menu.Item>

                                        </Menu.Dropdown>

                                    </Menu>

                                )}

                                {selectedRequest.status === "PENDING" && (
                                    <Button
                                        size="xs"
                                        color="red"
                                        variant="light"
                                        onClick={() => setRejectModal(true)}
                                    >
                                        Reject Fund Request
                                    </Button>
                                )}

                                {selectedRequest.depositeType === "Advance Credit" &&
                                    selectedRequest.status === "SUCCESS" && selectedRequest.IsadvanceCreditopen && (
                                        <Button
                                            size="xs"
                                            variant="outline"
                                            onClick={() => setadvancecreditrevertModal(true)}
                                        >
                                            Take Revert Advance Credit
                                        </Button>
                                    )}

                            </Group>

                            {/* {selectedRequest.status === 'PENDING' && <Button size="xs" variant="light" color="red">Reject fund request</Button>}
                            {(selectedRequest.depositeType === 'Advance Credit' && selectedRequest.status === 'SUCCESS') && <Button size="xs" variant="outline" >Take revert advance credit</Button>} */}
                        </Group>
                    </>
                )}
            </Drawer>

            <Modal
                opened={approveModal}
                onClose={() => setApproveModal(false)}
                centered
                title={
                    approveType === "NORMAL"
                        ? "Approve Fund Request"
                        : "Approve Fund Request With Fee"
                }
            >
                <Stack gap={2}>

                    <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            {selectedRequest?.userType}
                        </Text>

                        {/* <Text fw={600}>
                            {selectedRequest?.userName}
                        </Text> */}
                    </Group>

                    <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            {selectedRequest?.userType} Code
                        </Text>

                        <Badge>
                            {selectedRequest?.userCode}
                        </Badge>
                    </Group>

                    {/* <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            Mobile
                        </Text>

                        <Text>
                            {selectedRequest?.mobile}
                        </Text>
                    </Group> */}

                    <Divider />

                    <Group justify="space-between">
                        <Text size="sm" fw={600}>
                            Transfer Amount
                        </Text>

                        <Text
                            fw={700}
                            size="lg"
                            c="green"
                        >
                            ₹ {Number(selectedRequest?.amount).toLocaleString()}
                        </Text>
                    </Group>

                    {/* <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            Remarks
                        </Text>

                        <Text>
                            {transferInputs.remarks || "-"}
                        </Text>
                    </Group> */}

                </Stack>
                <Stack gap={3}>
                    {approveType === "WITH_FEE" && (

                        <NumberInput
                            label="Processing Fee"
                            placeholder="Enter fee"
                            value={approveForm.fee}
                            onChange={(value) =>
                                setApproveForm((prev) => ({
                                    ...prev,
                                    fee: value,
                                }))
                            }
                            min={0}
                            max={selectedRequest?.amount}
                            hideControls
                            withAsterisk
                        />

                    )}

                    <TextInput
                        label="Remarks (Optional)"
                        value={approveForm.adminapproveremarks}
                        onChange={(event) =>
                            setApproveForm((prev) => ({
                                ...prev,
                                adminapproveremarks: event.target.value,
                            }))
                        }
                    />
                    <Stack align="center">

                        <Text fw={600} mt={'xs'}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setmpin}
                            mask
                            size="lg"
                        />

                    </Stack>

                    <Button
                        mt={'md'}
                        fullWidth
                        size="md"
                        loading={approveloading}
                        // color="green"
                        onClick={handelApprove_Request}
                    >
                        Confirm Approved ₹ {Number(finalAmount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal>
            <Modal
                opened={rejectModal}
                onClose={() => setRejectModal(false)}
                centered
                title="Reject Fund Request"
            >
                <Stack gap={2}>

                    <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            {selectedRequest?.userType}
                        </Text>

                        {/* <Text fw={600}>
                            {selectedRequest?.userName}
                        </Text> */}
                    </Group>

                    <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            {selectedRequest?.userType} Code
                        </Text>

                        <Badge>
                            {selectedRequest?.userCode}
                        </Badge>
                    </Group>

                    {/* <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            Mobile
                        </Text>

                        <Text>
                            {selectedRequest?.mobile}
                        </Text>
                    </Group> */}

                    <Divider />

                    <Group justify="space-between">
                        <Text size="sm" fw={600}>
                            Reject Amount
                        </Text>

                        <Text
                            fw={700}
                            size="lg"
                            c="green"
                        >
                            ₹ {Number(selectedRequest?.amount).toLocaleString()}
                        </Text>
                    </Group>

                    {/* <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            Remarks
                        </Text>

                        <Text>
                            {transferInputs.remarks || "-"}
                        </Text>
                    </Group> */}

                </Stack>
                <Stack gap={3}>
                    <TextInput
                        label="Remarks"
                        value={approveForm.adminrejectremarks}
                        onChange={(event) =>
                            setApproveForm((prev) => ({
                                ...prev,
                                adminrejectremarks: event.target.value,
                            }))
                        }
                        withAsterisk
                    />
                    <Stack align="center">

                        <Text fw={600} mt={'xs'}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setmpin}
                            mask
                            size="lg"
                        />

                    </Stack>

                    <Button
                        mt={'md'}
                        fullWidth
                        size="md"
                        loading={rejectloading}
                        // color="green"
                        onClick={handelReject_Request}
                    >
                        Confirm Reject ₹ {Number(finalAmount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal>
            <Modal
                opened={advancecreditrevertModal}
                onClose={() => setadvancecreditrevertModal(false)}
                centered
                title="Revert Advance Credit Fund"
            >
                <Stack gap={2}>

                    <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            {selectedRequest?.userType}
                        </Text>

                        {/* <Text fw={600}>
                            {selectedRequest?.userName}
                        </Text> */}
                    </Group>

                    <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            {selectedRequest?.userType} Code
                        </Text>

                        <Badge>
                            {selectedRequest?.userCode}
                        </Badge>
                    </Group>

                    {/* <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            Mobile
                        </Text>

                        <Text>
                            {selectedRequest?.mobile}
                        </Text>
                    </Group> */}

                    <Divider />

                    <Group justify="space-between">
                        <Text size="sm" fw={600}>
                            Revert Amount
                        </Text>

                        <Text
                            fw={700}
                            size="lg"
                            c="green"
                        >
                            ₹ {Number(selectedRequest?.amount).toLocaleString()}
                        </Text>
                    </Group>

                    {/* <Group justify="space-between">
                        <Text size="sm" c="dimmed">
                            Remarks
                        </Text>

                        <Text>
                            {transferInputs.remarks || "-"}
                        </Text>
                    </Group> */}

                </Stack>
                <Stack gap={3}>
                    <TextInput
                        label="Remarks"
                        value={advanccreditrevertRemarks}
                        onChange={(e) => setadvanccreditrevertRemarks(e.target.value)}
                        withAsterisk
                    />
                    <Stack align="center">

                        <Text fw={600} mt={'xs'}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setmpin}
                            mask
                            size="lg"
                        />

                    </Stack>

                    <Button
                        mt={'md'}
                        fullWidth
                        size="md"
                        loading={revertloading}
                        // color="green"
                        onClick={handelRevert_Request}
                    >
                        Confirm Revert ₹ {Number(finalAmount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal>
        </>
    )
}
export default Fundrequest